import React, { useState, useEffect, useRef } from "react";

// ========================================
// TEXTE & INHALTE - HIER KANNST DU ALLES ÄNDERN!
// ========================================

const SITE_CONTENT = {
  // Header & Navigation
  siteName: "Tobias · Portfolio",
  siteTagline: "Fullstack-Entwickler & UI-Ingenieur",
  ctaButton: "Jetzt anfragen",
  
  // Hero Section
  hero: {
    mainTitle: "Willkommen auf meiner Modernen Portfolio Seite",
    highlightText: "Tobias S.",
    description: "Ich entwerfe und entwickle performante, zugängliche Web-Erlebnisse – mit Fokus auf sauberes Design, nachhaltige Architektur und Liebe zum Detail.",
    primaryButton: "Projekte ansehen",
    secondaryButton: "Mehr erfahren",
  },
  
  // About Section
  about: {
    eyebrow: "Über mich",
    title: "Angehender Fachinformatiker für",
    titleHighlight: "Anwendungsentwicklung",
    paragraph1: "34 Jahre alt, aktuell in der Umschulung zum Fachinformatiker für Anwendungsentwicklung. Mein Fokus: innovative Web- & App-Lösungen mit modernen Technologien und KI.",
    paragraph2: "Autodidakt mit Erfahrung durch YouTube, Udemy und eigene Projekte. Jetzt wird das Wissen professionell vertieft.",
    paragraph3: "Sportlich aktiv im American Football – Teamgeist, Disziplin und Zielstrebigkeit bringe ich auch in die digitale Arbeitswelt ein.",
    paragraph4: "Besonders begeistert mich die Welt der künstlichen Intelligenz. Ich möchte nicht nur verstehen, was KI leisten kann, sondern auch die besten Ressourcen und Praktiken kennenlernen, um sie optimal einzusetzen. Ein weiterer Schwerpunkt liegt auf N8N – der Erstellung maßgeschneiderter Workflows, die individuell auf spezifische Anforderungen zugeschnitten sind und Prozesse nachhaltig automatisieren.",
    paragraph5: "Meine beruflichen Ziele liegen im Consulting-Bereich, Projektmanagement und in der Prozessoptimierung. Ich möchte Unternehmen dabei unterstützen, ihre Abläufe effizienter zu gestalten, innovative Lösungen zu implementieren und durch strategisches Denken nachhaltigen Mehrwert zu schaffen.",
    stats: {
      projects: { value: "22+", label: "Projekte" },
      years: { value: "2", label: "Jahre Coding" },
      clients: { value: "∞", label: "Leidenschaft" },
    },
    skillsTitle: "Skills & Werkzeuge",
  },
  
  // Projects Section
  projects: {
    eyebrow: "Portfolio",
    title: "Meine Projekte",
    demoButton: "Demo Anwendung",
    adminButton: "zum Admin",
  },
  
  // Certificates Section
  certificates: {
    eyebrow: "Qualifikationen",
    title: "Zertifikate",
  },
  
  // Experience Section
  experience: {
    eyebrow: "Werdegang",
    title: "Experience & Background",
  },
  
  // Contact Section
  contact: {
    eyebrow: "Kontakt",
    title: "Lass uns über dein",
    titleHighlight: "deine Projekt idee",
    titleEnd: "sprechen",
    description: "Gerne baue ich auf Wunsch eine Webseite nach deinen Vorstellungen, soweit es machbar ist. Ob Neuentwicklung, Redesign oder Beratung – ich freue mich auf deine Nachricht und beantworte sie in der Regel innerhalb von 24 Stunden.",
    form: {
      nameLabel: "Name",
      namePlaceholder: "Wie darf ich dich ansprechen?",
      emailLabel: "E-Mail",
      emailPlaceholder: "deine@email.de",
      websiteLabel: "Website (optional)",
      websitePlaceholder: "https://deine-website.de",
      messageLabel: "Projektidee",
      messagePlaceholder: "Erzähl mir von deinem Projekt – ein paar Stichpunkte reichen völlig...",
      submitButton: "Nachricht senden",
    },
    direct: {
      title: "Direkt erreichen",
      whatsapp: {
        number: "+491718836921",
        text: "Hallo Tobias, ich habe dein Portfolio gesehen und habe eine Frage! \n\nBitte fülle das Kontaktformular aus für eine detaillierte Anfrage:\n\n👤 Name: [Bitte ausfüllen]\n📧 E-Mail: [Bitte ausfüllen]\n🌐 Website (optional): [Falls vorhanden]\n📝 Nachricht/Projektidee: [Bitte ausfüllen]",
        label: "WhatsApp",
      },
      github: {
        url: "https://github.com/Tobse2910",
        label: "GitHub Profil",
      },
      instagram: {
        url: "https://www.instagram.com/kicodebyts?utm_source=qr&igsh=MXc4eHJrbDdxZmU5dg==",
        label: "Instagram",
      },
    },
    availability: {
      status: "Verfügbar ab Oktober 2026",
      note: "Aktuell in der Umschulungs‑Praktikumsphase – neue Projekte werden für Q4/2026 geplant.",
    },
  },

  // Setup Section
  setup: {
    eyebrow: "Mein Workspace",
    title: "Das Setup hinter den",
    titleHighlight: "Projekten",
    description: "Mit der richtigen Hardware und Software entstehen großartige Dinge. Hier ist ein Einblick in meine Arbeitsumgebung.",
  },
  
  // Footer
  footer: {
    copyright: "Tobias. Entwickelt mit React & Tailwind CSS.",
  },
};

const NAV_ITEMS = [
  { id: "projekte", label: "Projekte" },
  { id: "uber-mich", label: "Über mich" },
  { id: "skills", label: "Skills" },
  { id: "setup", label: "Setup" },
  { id: "ki-schulungen", label: "KI-Schulungen" },
  { id: "kontakt", label: "Kontakt" },
];

const PROJECTS = [
  {
    title: "🎫 Ticket-Buchen-Alert",
    image: "/Allert triger (1).png",
    category: "anwendung",
    description:
      "Ein intelligentes Ticket-Monitoring-System, das Ticketmaster überwacht und Sie per Telegram benachrichtigt, sobald Tickets verfügbar werden. Mit Web-Dashboard zur Verwaltung. Features: Automatische Überwachung, Telegram-Benachrichtigungen, Web-Dashboard, Docker-Support.",
    link: "https://github.com/Tobse2910/Ticket-Buchen-Allert",
    buttonText: "Zum Github Download",
  },
  {
    title: "KI-Scanner",
    image: "/ki.svg",
    category: "web-app",
    description: "Ein innovativer KI-Scanner für präzise Analysen und schnelle Datenerfassung. Dieses Tool nutzt modernste Algorithmen, um Inhalte effizient zu erkennen und auszuwerten – optimiert für nahtlose Performance.",
    link: "https://www.kicodebyts.com/KI-Scenner/",
  },
  {
    title: "Der Arbeitszeugnis-Analytiker",
    image: "/Bildarbeitszeugniss.jpg",
    category: "anwendung",
    description:
      "Das Tool 'Arbeitszeugnis Analyse' ermöglicht eine schnelle und automatisierte Auswertung von Arbeitszeugnissen. Nutzer können ein PDF hochladen, das System analysiert den Inhalt, vergibt eine Schulnote (z. B. '1 = Sehr gut') und liefert eine kompakte Zusammenfassung. So erhalten Mitarbeitende und Personalverantwortliche auf einen Blick eine objektive Einschätzung der Zeugnisqualität.",
    link: "https://www.kicodebyts.com/Arbeitszeugniss",
  },
  {
    title: "Die Wetter anzeige",
    image: "/Wetter.png",
    category: "anwendung",
    description:
      "Die Wetter-App ist eine benutzerfreundliche Anwendung, die aktuelle Wetterdaten für jeden Ort weltweit anzeigt. Sie bietet eine klare und ansprechende Benutzeroberfläche, die es einfach macht, das Wetter zu überprüfen.",
    link: "https://www.kicodebyts.com/Wetter-anzeige",
  },
  {
    title: "🎯 Rookie Event Management",
    image: "/Rooki-Event.jpeg",
    category: "anwendung",
    description:
      "Projekt für meine Rookie-Prüfung zur Umsetzung eines Event-Originals. Grundlage für weitere Events oder Vereine, um Organisation und Abläufe effizient zu ermöglichen.",
    link: "https://www.kicodebyts.com/doner-undav-show/",
  },
  {
    title: "EventMatcher",
    image: "/Logo-weiße-schrift.png",
    category: "laufende-prozesse",
    description:
      "EventMatcher ist ein smartes Event-System, mit dem sich fremde Menschen auf Veranstaltungen z.B. Partys, Festivals oder private Events diskret anhand ihrer Interessen und Absichten finden können. Das funktioniert über ein konfigurierbares Armband und ein digitales Profil.",
    
  },
  {
    title: "🛡️ CyberShield",
    image: "/CyberShield1.png",
    category: "anwendung",
    description:
      "CyberShield ist ein interaktives Webtool zur Analyse, Meldung und Visualisierung von Cyber-Bedrohungen in Echtzeit. Nutzer können verdächtige Inhalte wie E-Mails analysieren lassen, eigene Vorfälle melden und aktuelle Bedrohungstrends auf einer Weltkarte oder in Form von Statistiken einsehen. Das Tool fördert die Zusammenarbeit in der Cybersicherheits-Community und bietet eine Plattform für den Austausch von Informationen und Erfahrungen. Ziel ist es, digitale Sicherheit für alle zugänglich, verständlich und transparent zu machen – von Privatpersonen bis zu Behörden.",
    link: "https://www.kicodebyts.com/Cyber_anwendung",
  },
  {
    title: "SentinelView",
    image: "/CyberShield.png",
    category: "anwendung",
    description:
      "🛡️ SentinelView – Webbasierte Cyber Überwachungsplattform für Organisationen. SentinelView ist eine moderne mandantenfähige Webanwendung zur Echtzeitüberwachung digitaler Infrastrukturen. Behörden, Unternehmen und Bildungseinrichtungen können damit Bedrohungen erkennen, analysieren sowie dokumentieren inklusive Live-Dashboard, Kartenvisualisierung, Benutzerverwaltung, KI-gestützter Analyse und rollenbasiertem Zugriffssystem.",
    link: "https://www.kicodebyts.com/SentinelView",
  },
  {
    title: "🎧 DJ Wishboard",
    image: "/DJ-Logo.png",
    category: "web-app",
    description:
      "DJ WISHBOARD ist eine innovative, webbasierte Wunschplattform für Events, Partys und Clubs – entwickelt für DJs, Gäste und Veranstalter. DJ Wishboard ist eine moderne Web-App zur Verwaltung von Musikwünschen auf Events. Gäste senden ihre Wünsche per QR-Code, der DJ verwaltet diese live im Panel – inkl. Status (angenommen, gespielt), Like-System und Echtzeit-Feedback. Die Plattform bietet: QR-basiertes Wunschformular, DJ-Panel mit Statuskontrolle, Like- & Rangsystem, Mobile-optimiertes Design (Darkmode, Glassmorphism), Veranstalter-Login & Eventsteuerung. Ideal für Clubs, Hochzeiten und Firmenevents. Entwickelt mit PHP, MySQL & Tailwind CSS.",
    link: "https://www.kicodebyts.com/Dj_wunschliste_Premium",
  },
  {
    title: "⏱️ Zeiterfassungssystem",
    image: "/Zeiterfassung.png",
    category: "web-app",
    description:
      "Modernes Zeiterfassungssystem für Unternehmen und Teams. Mitarbeiter können ihre Arbeitszeiten einfach erfassen, Pausen dokumentieren und Projekte zuordnen. Mit übersichtlichen Reports und Exportfunktionen für die Lohnabrechnung.",
    link: "https://www.kicodebyts.com/zeiterfassung/public/",
  },
  {
    title: "🏠 DachAnalyse",
    image: "/dachanalyse.svg",
    category: "web-app",
    description:
      "Professionelle Dachzustandsanalyse mit Satellitenkarten-Integration und Adressbuch. Gebietserkundung und Dachzustand systematisch erfassen, dokumentieren und bewerten – mit Leaflet-Karten, PWA-Unterstützung und offline-fähiger Oberfläche. Zielgruppe: Dachdecker, Inspektoren und Immobilien-Profis.",
    link: "https://www.kicodebyts.com/dachanalyse",
  },
  {
    title: "💸 FinanzFlow",
    image: "https://finanz-app.eu/finanz.png",
    category: "web-app",
    description:
      "Smarte Finanz- und Fahrzeugverwaltung mit Budget-Tracking, Tankstellen-Finder und detaillierten Ausgaben-Statistiken.",
    link: "https://finanz-app.eu/",
  },
  {
    title: "📅 Business-Jobagent",
    image: "/icon.svg",
    category: "web-app",
    description:
      "Moderne Buchungsplattform für mobile & Beauty-Dienstleister. QR-Code scannen, verfügbare Termine sehen, direkt buchen - ohne Umwege.",
    link: "https://www.business-jobagent.de",
  },
  {
    title: "📶 Gäste-WLAN Portal",
    image: "/guest-wifi-portal.jpeg",
    category: "webseite",
    description:
      "Captive-Portal für öffentliches Gäste-WLAN: markengerechter Login-Screen mit Zustimmung zu Nutzungsbedingungen, DSGVO-Datenschutzhinweis, Dark-/Light-Mode und Umschaltung zwischen Deutsch und Englisch. Gebaut mit React, Vite und Tailwind – zugeschnitten auf Cafés, Hotels und Locations, die einen rechtssicheren WLAN-Zugang brauchen. Der Quellcode ist Open Source und steht auf GitHub zum Download bereit.",
    link: "https://www.kicodebyts.com/guest-wifi-portal/",
    github: "https://github.com/Tobse2910/guest-wifi-portal",
  },
  {
    title: "🎶 PartyFlow",
    image: "/Projektbilder/PartyFlow-Werbung.jpg",
    category: "android-app",
    description:
      "Schluss mit „Kannst du mal eben diesen Song spielen?“ Mit PartyFlow wünschen sich deine Gäste Musik per QR-Code – ohne App, ohne Konto. Läuft direkt in deiner Spotify-Warteschlange, passend zur Stimmung. Für Hochzeit, Geburtstag & jede Feier.",
    link: "https://partyflow.kicodebyts.com",
    buttonText: "Zur Anwendung",
  },
  {
    title: "🍺 Fest-Bestellsystem",
    image: "/Feste-app.jpg",
    category: "android-app",
    description:
      "Browserbasiertes Kassen- und Ausschanksystem für Straßenfeste und Vereinsfeiern – läuft ohne Installation direkt auf Tablets und Handys. Drei Rollen greifen in Echtzeit ineinander: Die Kasse nimmt Bestellungen auf, die Bar hakt sie ab, Pfand wird automatisch verrechnet und der Admin sieht Umsatz, Bestände und Statistik live im Dashboard. Getränke, Preise, Kategorien und das Design pflegt man komplett im Browser – ohne Datei-Upload. Der komplette Quellcode ist Open Source (MIT) und steht auf GitHub zum Download bereit.",
    link: "https://www.kicodebyts.com/Feste/",
    github: "https://github.com/Tobse2910/fest-bestellsystem",
  },
  {
    title: "👴 Opa UWE Projekt",
    image: "/Opa-UWE-bild.jpg",
    category: "webseite",
    description:
      "Ich habe ihm eine Webseite gebaut, damit er seine GTA‑Fähigkeiten zeigen kann, insbesondere das Designen von GTA‑RP‑Fahrzeugen.",
    link: "https://www.kicodebyts.com/UWE-webseite",
  },
  {
    title: "💪 SteelFlex ",
    image: "/steelflexbild.jpg",
    category: "webseite",
    description:
      "Angebotsseite für STEELFLEX, um Leistungen klar zu präsentieren und Anfragen zu generieren.",
    link: "https://www.kicodebyts.com/Steelfex-webseite",
  },
  {
    title: "🧹 SupremeClean",
    image: "/SupremeClean-webseitenbanner.jpg",
    category: "webseite",
    description:
      "Professionelle Webseite für Reinigungsdienste. Mit Online-Buchung, Preiskalkulator, Mitarbeiterverwaltung und Kundenportal. Moderne Lösung für Gebäudereinigung und Facility Management.",
    link: "https://www.kicodebyts.com/SuperemeClean",
  },
  {
    title: "🔧 Montage-Service",
    image: "/Montage-webseite.jpg",
    category: "webseite",
    description:
      "Digitale Plattform für Montage- und Handwerksdienstleistungen. Kunden können Aufträge online buchen, Techniker werden automatisch zugewiesen und der gesamte Prozess wird dokumentiert.",
    link: "https://www.kicodebyts.com/Geery-webseite",
  },
  {
    title: "Verwaltungssystem",
    image: "/VK-Polizei.png",
    category: "anwendung",
    description:
      "Internes Verwaltungssystem für Polizeibehörden. Verwaltung von Einsätzen, Dokumentation, Fahrzeugflotte und Personal. Mit Zugriffskontrolle und verschlüsselter Datenbank.",
    link: "https://www.kicodebyts.com/VK-Assist-Polizei",
  },
  {
    title: "🚒 Feuerwehr-Webseite",
    image: "/Feuerwehr.jpeg",
    category: "webseite",
    description:
      "Webseite für GTA RP, genutzt als Aushänge‑Schild für Informationen, Regeln und Ankündigungen der Feuerwehr im RP.",
    link: "https://www.kicodebyts.com/Feuerwehr-Talstein",
  },
  {
    title: "🚁 Luftrettungs-Webseite",
    image: "/Luftretung.jpg",
    category: "webseite",
    description:
      "Webseite für GTA RP, die als Aushänge‑Schild für die Luftrettung dient – mit Infos, Abläufen und Ankündigungen.",
    link: "https://www.kicodebyts.com/Luftrettung-Talstein",
  },
  {
    title: "🚁 Luftrettung - Gaming Code Entwicklung (Lua)",
    image: "/Luftrettungs-wache.jpeg",
    category: "gaming-lua",
    description:
      "Lua-basierte Gaming-Skripte für die Luftrettungs-Simulation. Entwicklung von realistischen Rettungsmissionen, Fahrzeugsteuerung und Gameplay-Mechaniken.",
    link: "https://steelflex.tebex.io/package/luftrettungv3vinewoodhills",
  },
  {
    title: "🏧 Bankautomaten-System (Lua)",
    category: "gaming-lua",
    isGallery: true,
    description:
      "Selbst entwickeltes Lua-Skript für interaktive Geldautomaten im GTA RP. Spieler können Bargeld abheben, einzahlen und ihren Kontostand prüfen – mit sauberer Benutzeroberfläche und sicherer Server-Anbindung.",
    images: [
      "/Gta-skripte/Bank_automaten/MedalTVGrandTheftAutoVFiveM20260617224741403.webp",
      "/Gta-skripte/Bank_automaten/MedalTVGrandTheftAutoVFiveM20260618004936595.webp",
      "/Gta-skripte/Bank_automaten/MedalTVGrandTheftAutoVFiveM20260618004939210.webp",
      "/Gta-skripte/Bank_automaten/MedalTVGrandTheftAutoVFiveM20260618004943553.webp",
    ],
  },
  {
    title: "🏦 Banking-System (Lua)",
    category: "gaming-lua",
    isGallery: true,
    description:
      "Umfangreiches Banking-System mit Überweisungen, mehreren Konten, Transaktions-Historie und Automaten-Anbindung. Eine komplette digitale Finanzverwaltung für die gesamte RP-Stadt.",
    images: [
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260606111922928.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260606112113016.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260609011641924.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260612172955286.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220212966.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220223343.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220225559.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220227371.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220229285.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220232813.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220238359.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220241082.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220243296.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220248236.webp",
      "/Gta-skripte/Vl-Banking/MedalTVGrandTheftAutoVFiveM20260617220312212.webp",
    ],
  },
  {
    title: "🏛️ Rathaus-System (Lua)",
    category: "gaming-lua",
    isGallery: true,
    description:
      "Rathaus-Skript zur Verwaltung von Bürgern, Dokumenten und Anträgen. Inklusive Ausweisstelle, An- & Abmeldungen sowie behördlichen Abläufen für ein realistisches Stadt-Roleplay.",
    images: [
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220025936.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220048731.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220054778.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220118966.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220122191.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220124405.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220126816.webp",
      "/Gta-skripte/Rathaus/MedalTVGrandTheftAutoVFiveM20260617220128830.webp",
    ],
  },
  {
    title: "💻 In-Game PC / Laptop-System (Lua)",
    category: "gaming-lua",
    isGallery: true,
    description:
      "In-Game Computer- bzw. Laptop-System mit eigenen Apps, Nachrichten und Verwaltungsfunktionen. Die zentrale digitale Schnittstelle für Aufgaben und Kommunikation im RP.",
    images: [
      "/Gta-skripte/vl-PC/MedalTVGrandTheftAutoVFiveM20260606000159498.webp",
      "/Gta-skripte/vl-PC/MedalTVGrandTheftAutoVFiveM20260617220314930.webp",
      "/Gta-skripte/vl-PC/MedalTVGrandTheftAutoVFiveM20260617220321988.webp",
      "/Gta-skripte/vl-PC/MedalTVGrandTheftAutoVFiveM20260617220334488.webp",
    ],
  },
  {
    title: "🧾 Rechnungs-System (Lua)",
    category: "gaming-lua",
    isGallery: true,
    description:
      "Rechnungs-System für Spieler und Unternehmen. Rechnungen lassen sich direkt im Spiel erstellen, versenden und bezahlen – ideal für ein authentisches Firmen- und Wirtschafts-RP.",
    images: [
      "/Gta-skripte/recnnungen/MedalTVGrandTheftAutoVFiveM20260617220641347.webp",
      "/Gta-skripte/recnnungen/MedalTVGrandTheftAutoVFiveM20260617220644162.webp",
      "/Gta-skripte/recnnungen/MedalTVGrandTheftAutoVFiveM20260617220703195.webp",
    ],
  },
  {
    title: "🎒 Inventar-System (Lua)",
    category: "gaming-lua",
    isGallery: true,
    description:
      "Modernes Inventar-System mit Item-Verwaltung, Gewichtslimits und Slot-basierter Organisation. Sorgt für ein übersichtliches und realistisches Item-Handling im Roleplay.",
    images: [
      "/Gta-skripte/Inwentar/MedalTVGrandTheftAutoVFiveM20260617220404296.webp",
    ],
  },
  {
    title: "🎪 Eventtechnik-Webseite",
    image: "/Eventveranstalung.jpg",
    category: "webseite",
    description:
      "Umfassende Event-Management-Software für Veranstaltungen jeder Größe. Von Planung über Ticketing bis zur Nachbereitung – alle Tools für erfolgreiche Events.",
    link: "https://www.kicodebyts.com/alex-evnettechnik",
  },
  {
    title: "👤 Eventtechnik-Webseite",
    image: "/Alex1.png",
    category: "webseite",
    description:
      "Moderne Website für DJ- & Eventdienstleistungen (StageSync) mit klaren Service-Bereichen für DJ, Ton, Licht und Bühne, Referenzen, Galerie sowie Anfrage- und Verfügbarkeits-Flow für Buchungen.",
    link: "https://www.kicodebyts.com/alex-webseite-neueversion",
  },
  {
    title: "🎯 Gerry Business Solutions",
    image: "/Gerry.png",
    category: "webseite",
    description:
      "Business-Management-Suite für kleine und mittelständische Unternehmen. CRM, Projektmanagement, Buchhaltung und Team-Kollaboration in einer Plattform.",
    link: "https://www.kicodebyts.com/Geery-webseite",
  },
  {
    title: "Was wird Lensumatch ?",
    image: "",
    category: "laufende-prozesse",
    description:
      "Lasst euch überraschen",
    
  },
  {
    title: "Was wird Lensumatch Marketplace",
    image: "",
    category: "laufende-prozesse",
    description:
      "Lasst euch überraschen",
    
  },
  {
    title: "CalendarScannerApp",
    image: "/CalendarScannerApp.png",
    category: "laufende-prozesse",
    description:
      "CalendarScannerApp ist eine smarte Anwendung zum Scannen und Abgleichen von Terminen. Die App synchronisiert automatisch Termine zwischen dem Handy-Kalender und Outlook-Kalender, erkennt Konflikte und hilft bei der effizienten Terminplanung. Ideal für alle, die mehrere Kalender verwalten und den Überblick behalten möchten.",
    link: "/demo.html",
  },
];

const CERTIFICATES = [
  {
    title: "Entry-Level Python Programming",
    image: "/zrtifikat1.png",
    issuer: "Python Institute",
    date: "2024",
    description: "PCEP - Certified Entry-Level Python Programmer",
  },
  {
    title: "Bild & Grafikdesign",
    image: "/Grafikdesing.png",
    issuer: "Zertifikat",
    date: "2018",
    description: "Darstellung von Bildern und Grafiken mit professionellen Tools.",
  },
];

const SKILLS = [
  { name: "React & Next.js", level: 95, icon: "⚛️" },
  { name: "TypeScript", level: 90, icon: "📘" },
  { name: "Tailwind CSS", level: 95, icon: "🎨" },
  { name: "Node.js & APIs", level: 85, icon: "🔌" },
  { name: "UI/UX Thinking", level: 88, icon: "✨" },
  { name: "Performance Opt.", level: 90, icon: "⚡" },
  { name: "KI Prompting", level: 99, icon: "🤖" },
  { name: "Prozessoptimierung", level: 99, icon: "📊" },
  { name: "Logo & Grafik Design", level: 99, icon: "🎭" },
  { name: "Consulting", level: 99, icon: "💼" },
];

const DESIGN_COMPONENTS = [
  { color: "from-accent-600 to-accent-400", label: "Responsiv" },
  { color: "from-emerald-600 to-emerald-400", label: "A11y" },
  { color: "from-accent-600 to-accent-400", label: "Dark Mode" },
  { color: "from-amber-600 to-amber-400", label: "Modern" },
];

const EXPERIENCE = [
  {
    role: "Umschulung Fachinformatiker",
    company: "Anwendungsentwicklung",
    period: "2024 – heute",
    description:
      "Intensive Weiterbildung in moderner Softwareentwicklung mit Fokus auf Web- und App-Entwicklung. Praktische Projekte mit React, Node.js und KI-Integration. Aufbau eines umfangreichen Projektportfolios.",
    badge: "Aktuell",
  },
  {
    role: "Autodidaktisches Lernen",
    company: "YouTube, Udemy & Praxis",
    period: "2020 – 2024",
    description:
      "Selbstständige Aneignung von Programmierkenntnissen durch Online-Kurse und eigene Projekte. Entwicklung von über 20 Webanwendungen, von Ticketsystemen bis zu komplexen Management-Plattformen. Kontinuierliche Weiterbildung in neuen Technologien.",
    badge: "Selbststudium",
  },
  {
    role: "American Football Spieler",
    company: "Teamgeist & Disziplin",
    period: "seit vielen Jahren",
    description:
      "Langjährige sportliche Leidenschaft, die Teamarbeit, Ausdauer und strategisches Denken fördert. Diese Eigenschaften bringe ich täglich in meine IT-Projekte ein – von der Planung bis zur Umsetzung.",
    badge: "Sport",
  },
  {
    role: "KI & Workflow Automation",
    company: "Zukunftsorientierte Technologien",
    period: "Aktueller Fokus",
    description:
      "Besonders begeistert mich die Welt der künstlichen Intelligenz. Ich möchte nicht nur verstehen, was KI leisten kann, sondern auch die besten Ressourcen und Praktiken kennenlernen, um sie optimal einzusetzen. Ein weiterer Schwerpunkt liegt auf N8N – der Erstellung maßgeschneiderter Workflows, die individuell auf spezifische Anforderungen zugeschnitten sind und Prozesse nachhaltig automatisieren.",
    badge: "KI & N8N",
  },
  {
    role: "Berufliche Ziele",
    company: "Consulting & Projektmanagement",
    period: "Zukünftige Vision",
    description:
      "Meine beruflichen Ziele liegen im Consulting-Bereich, Projektmanagement und in der Prozessoptimierung. Ich möchte Unternehmen dabei unterstützen, ihre Abläufe effizienter zu gestalten, innovative Lösungen zu implementieren und durch strategisches Denken nachhaltigen Mehrwert zu schaffen.",
    badge: "🎯 Ziele",
  },
];

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showScrollNotification, setShowScrollNotification] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showCta, setShowCta] = useState(false);

  useEffect(() => {
    const target = document.getElementById("skills");
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          setShowCta(true);
          observer.disconnect();
        }
      },
      { root: null, threshold: 0 }
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  // PWA Install Prompt Handler
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  // Scroll Detection for Notification
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300 && !hasScrolled) {
        setShowScrollNotification(true);
        setHasScrolled(true);
        
        // Auto-hide after 8 seconds
        setTimeout(() => {
          setShowScrollNotification(false);
        }, 8000);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);

  return (
    <div className="min-h-screen text-neutral-100 overflow-hidden" style={{background: '#0a0a0a'}}>
      <GradientBackground />
      <Header showCta={showCta} />
      <main className="relative z-10">
        <Hero />
        <About />
        <Projects />
        <Certificates />
        <Experience />
        <Setup />
        <KISchulungen setSelectedPackage={setSelectedPackage} />
        <Contact deferredPrompt={deferredPrompt} setDeferredPrompt={setDeferredPrompt} selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />
      </main>
      
      {/* Scroll Notification for PWA */}
      {showScrollNotification && (
        <div className="fixed top-24 right-6 z-50 animate-slide-down">
          <div className="bg-gradient-to-r from-accent-500 to-accent-500 text-white px-6 py-4 rounded-2xl shadow-2xl max-w-md">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl overflow-hidden bg-white/10 flex-shrink-0">
                <img src="/Meinlogo-animiert.gif" alt="Logo" className="w-full h-full object-cover" />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-sm">Mein Portfolio als App!</p>
                <p className="text-xs opacity-90 mt-1">
                  Installiere meine Portfolio-Seite als App auf deinem Handy
                </p>
              </div>
              <button
                onClick={() => {
                  document.getElementById('install-button').scrollIntoView({ behavior: 'smooth', block: 'center' });
                  setShowScrollNotification(false);
                }}
                className="px-4 py-2 bg-white text-accent-600 rounded-lg text-sm font-medium hover:bg-neutral-100 transition-all"
              >
                Zeig mir
              </button>
            </div>
          </div>
        </div>
      )}
      
      <CookieBanner />
      <footer className="relative z-10 border-t border-white/5 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl overflow-hidden">
                <img src="/Meinlogo-animiert.gif" alt="Logo" className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">Tobias · Schlothane</p>
                <p className="text-xs text-neutral-400">Fullstack-Entwickler & UI-Ingenieur</p>
              </div>
            </div>
          </div>
          
          {/* Legal Links */}
          <div className="mt-6 flex flex-wrap justify-center gap-6 text-sm">
            <button
              onClick={() => setShowImpressum(true)}
              className="text-neutral-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
            >
              Impressum
            </button>
            <span className="text-neutral-700">|</span>
            <button
              onClick={() => setShowDatenschutz(true)}
              className="text-neutral-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
            >
              Datenschutz
            </button>
          </div>

          <div className="mt-8 pt-8 border-t border-white/5 text-center">
            <p className="text-sm text-neutral-400">
              © {new Date().getFullYear()} {SITE_CONTENT.footer.copyright}
            </p>
          </div>
        </div>
      </footer>

      {/* Impressum Modal */}
      {showImpressum && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 animate-fade-in" onClick={() => setShowImpressum(false)}>
          <div className="relative max-w-3xl w-full max-h-[80vh] overflow-y-auto bg-neutral-900 border border-accent-500/50 rounded-2xl p-8 shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setShowImpressum(false)}
              className="absolute top-4 right-4 h-10 w-10 rounded-lg bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 hover:border-accent-500 transition-all duration-300 flex items-center justify-center text-white text-xl"
            >
              ×
            </button>
            <h2 className="text-3xl font-bold text-white mb-6">Impressum</h2>
            <div className="space-y-6 text-neutral-300">
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">Angaben gemäß § 5 TMG</h3>
                <p>Tobias Schlothane<br />Murrhardter Straße 54<br />73642 Welzheim<br />Deutschland</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">Kontakt</h3>
                <p>E-Mail: Kicodebyts@outlook.com</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
                <p>Tobias Schlothane<br />Murrhardter Straße 54<br />73642 Welzheim</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">Umsatzsteuer</h3>
                <p>Kleinunternehmer gemäß § 19 UStG. Es wird daher keine Umsatzsteuer ausgewiesen.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">Streitschlichtung</h3>
                <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-accent-400 hover:text-accent-300">https://ec.europa.eu/consumers/odr/</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Datenschutz Modal */}
      {showDatenschutz && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 animate-fade-in" onClick={() => setShowDatenschutz(false)}>
          <div className="relative max-w-3xl w-full max-h-[80vh] overflow-y-auto bg-neutral-900 border border-accent-500/50 rounded-2xl p-8 shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setShowDatenschutz(false)}
              className="absolute top-4 right-4 h-10 w-10 rounded-lg bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 hover:border-accent-500 transition-all duration-300 flex items-center justify-center text-white text-xl"
            >
              ×
            </button>
            <h2 className="text-3xl font-bold text-white mb-6">Datenschutzerklärung</h2>
            <div className="space-y-6 text-neutral-300">
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">1. Datenschutz auf einen Blick</h3>
                <h4 className="text-lg font-semibold text-white mb-2">Allgemeine Hinweise</h4>
                <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">2. Datenerfassung auf dieser Website</h3>
                <h4 className="text-lg font-semibold text-white mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
                <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
                <h4 className="text-lg font-semibold text-white mb-2 mt-4">Wie erfassen wir Ihre Daten?</h4>
                <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
                <p className="mt-2">Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">3. Hosting</h3>
                <p>Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">4. Cookies</h3>
                <p>Diese Website verwendet nur technisch notwendige Cookies zur Funktionalität der Website. Es werden keine Tracking- oder Analytics-Cookies verwendet.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-accent-400 mb-2">5. Ihre Rechte</h3>
                <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.</p>
              </div>
              <div className="text-sm text-neutral-500 italic">
                * Dies ist ein Demo-Text. Bitte durch vollständige Datenschutzerklärung ersetzen (z.B. von einem Datenschutz-Generator).
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-50 animate-slide-up">
      <div className="bg-neutral-900/95 backdrop-blur-xl border border-accent-500/20 rounded-2xl p-6 shadow-2xl">
        <div className="flex items-start gap-4">
          <span className="text-2xl">🍪</span>
          <div className="flex-1 space-y-3">
            <h3 className="font-semibold text-white">Cookies & Datenschutz</h3>
            <p className="text-sm text-neutral-300 leading-relaxed">
              Diese Website verwendet nur technisch notwendige Cookies für die Funktionalität. Keine Tracking- oder Analytics-Cookies.
            </p>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={acceptCookies}
                className="px-4 py-2 rounded-lg bg-gradient-to-r from-accent-500 to-accent-500 text-white text-sm font-medium hover:shadow-[0_0_20px_rgba(224,112,48,0.22)] transition-all duration-300"
              >
                Verstanden
              </button>
              <button
                onClick={declineCookies}
                className="px-4 py-2 rounded-lg bg-neutral-800 text-neutral-300 text-sm font-medium hover:bg-neutral-700 transition-all duration-300"
              >
                Ablehnen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function GradientBackground() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <div className="absolute -top-40 -left-32 h-96 w-96 rounded-full bg-accent-500/20 blur-3xl animate-pulse" />
      <div className="absolute top-40 -right-32 h-96 w-96 rounded-full bg-accent-500/20 blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
      <div className="absolute bottom-20 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-accent-500/10 blur-3xl animate-pulse" style={{ animationDelay: "2s" }} />
    </div>
  );
}

function Header({ showCta }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled 
          ? "backdrop-blur-xl bg-neutral-950/90 border-b border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.4)]" 
          : "backdrop-blur-sm bg-transparent border-b border-white/5"
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-3 group">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-accent-500 to-accent-500 rounded-2xl blur-lg opacity-50 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative h-10 w-10 rounded-xl overflow-hidden shadow-lg group-hover:scale-110 transition-transform duration-300">
                <img src="/Meinlogo-animiert.gif" alt="Logo" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="hidden sm:block">
              <p className="text-sm font-semibold text-white leading-tight">Tobias · Schlothane</p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item, index) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="relative text-sm text-neutral-300 hover:text-white transition-colors group"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-accent-500 to-accent-500 group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden relative z-50 w-10 h-10 flex flex-col items-center justify-center gap-1.5"
            aria-label="Menu"
          >
            <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? "opacity-0" : ""}`} />
            <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
          </button>

          {/* Desktop CTA Button */}
          {showCta && (
            <button
              onClick={() => {
                document.getElementById("kontakt")?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
              className="hidden md:block group relative px-5 py-2.5 rounded-xl bg-gradient-to-r from-accent-500 to-accent-500 text-sm font-medium text-white overflow-hidden hover:shadow-[0_0_30px_rgba(224,112,48,0.22)] transition-all duration-300 hover:scale-105"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-accent-500 to-accent-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="relative flex items-center gap-2">
                Jetzt anfragen
                <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
              </span>
            </button>
          )}
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 z-40 md:hidden transition-opacity duration-300 ${mobileMenuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/90 backdrop-blur-md" onClick={closeMobileMenu} />

        {/* Sidebar */}
        <div className={`absolute top-0 right-0 h-full w-72 bg-gradient-to-b from-neutral-900 via-neutral-950 to-black border-l border-accent-500/20 transform transition-transform duration-300 ease-out ${mobileMenuOpen ? "translate-x-0" : "translate-x-full"}`}>
          <div className="flex flex-col h-full p-6 pt-24">
            {/* Profile Section */}
            <div className="flex items-center gap-4 mb-12 pb-6 border-b border-white/10">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-tr from-accent-500 to-accent-500 rounded-2xl blur-md opacity-75" />
                <div className="relative h-14 w-14 rounded-xl overflow-hidden">
                  <img src="/Meinlogo-animiert.gif" alt="Logo" className="w-full h-full object-cover" />
                </div>
              </div>
              <div>
                <div className="text-base font-bold text-white">Tobias Schlothane</div>
                <div className="text-sm text-accent-400">Full-Stack Developer</div>
              </div>
            </div>

            {/* Menu Links */}
            <nav className="flex flex-col gap-2">
              {NAV_ITEMS.map((item, index) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={closeMobileMenu}
                  className="group flex items-center gap-4 px-4 py-3.5 rounded-xl text-neutral-300 hover:text-white hover:bg-gradient-to-r hover:from-accent-500/10 hover:to-accent-500/10 border border-transparent hover:border-accent-500/20 transition-all duration-200"
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <span className="w-1.5 h-8 bg-gradient-to-b from-accent-500 to-accent-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span className="text-base font-medium">{item.label}</span>
                </a>
              ))}
            </nav>

            {/* Mobile CTA Button */}
            {showCta && (
              <button
                onClick={() => {
                  closeMobileMenu();
                  document.getElementById("kontakt")?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
                className="mt-8 w-full group relative px-5 py-3 rounded-xl bg-gradient-to-r from-accent-500 to-accent-500 text-sm font-medium text-white overflow-hidden hover:shadow-[0_0_30px_rgba(224,112,48,0.22)] transition-all duration-300"
              >
                <span className="relative flex items-center justify-center gap-2">
                  Jetzt anfragen
                  <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                </span>
              </button>
            )}

            {/* Footer */}
            <div className="mt-auto pt-6 border-t border-white/10">
              <div className="text-xs text-neutral-500 text-center">© 2026 KiCodeByts</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Hero() {
  return (
    <section id="home" className="min-h-[94vh] pt-36 pb-24 flex items-center">
      <div className="max-w-5xl mx-auto px-6 w-full text-center">
        {/* Eyebrow / Status */}
        <p className="animate-fade-in inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-neutral-400 mb-8">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
          Fullstack-Entwickler &amp; UI-Ingenieur
        </p>

        {/* Editoriale Display-Headline mit kursiven Serif-Akzenten */}
        <h1 className="display-xl text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] font-bold animate-slide-up">
          Ich gestalte{" "}
          <span className="serif-italic font-normal text-accent-400">durchdachte</span>
          <br className="hidden sm:block" />{" "}
          digitale Produkte, von der{" "}
          <span className="serif-italic font-normal">ersten Idee</span>
          <br className="hidden sm:block" />{" "}
          bis zur fertigen{" "}
          <span className="serif-italic font-normal text-accent-400">App.</span>
        </h1>

        {/* Description */}
        <p className="mt-10 text-lg md:text-xl text-neutral-300/90 max-w-2xl mx-auto leading-relaxed">
          {SITE_CONTENT.hero.description}
        </p>

        {/* CTA Buttons */}
        <div className="mt-12 flex flex-wrap gap-4 justify-center animate-fade-in" style={{ animationDelay: "250ms" }}>
          <a
            href="#projekte"
            className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-accent-400 text-neutral-950 font-semibold hover:bg-accent-300 transition-all duration-300"
          >
            {SITE_CONTENT.hero.primaryButton}
            <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
          </a>
          <a
            href="#uber-mich"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-neutral-700 text-neutral-200 font-medium hover:border-neutral-500 hover:bg-neutral-900/60 transition-all duration-300"
          >
            {SITE_CONTENT.hero.secondaryButton}
          </a>
        </div>

        {/* Signatur-Zeile */}
        <p className="mt-16 text-sm text-neutral-500 animate-fade-in" style={{ animationDelay: "400ms" }}>
          Tobias Schlothane · Region Backnang / Stuttgart
        </p>
      </div>
    </section>
  );
}

function Metric({ label, value }) {
  return (
    <div className="rounded-lg border border-white/5 bg-neutral-900/80 px-3 py-2 hover:border-brand-400/50 hover:bg-neutral-800 hover:scale-105 transition-all duration-300 cursor-default group">
      <p className="text-[10px] text-neutral-400 group-hover:text-brand-300 transition-colors">{label}</p>
      <p className="text-sm font-semibold group-hover:text-white transition-colors">{value}</p>
    </div>
  );
}

function SectionTitle({ id, eyebrow, title, children }) {
  return (
    <section id={id} className="py-12 scroll-mt-24">
      <p className="text-xs uppercase tracking-[0.3em] text-brand-300 mb-2">
        {eyebrow}
      </p>
      <h2 className="text-2xl md:text-3xl font-semibold mb-3">{title}</h2>
      {children}
    </section>
  );
}

function About() {
  const [isVisible, setIsVisible] = useState(false);
  const skillsRef = useRef(null);

  useEffect(() => {
    const currentRef = skillsRef.current;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            console.log('Skills visible - starting animation');
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isVisible]);

  return (
    <section id="uber-mich" className="py-16 md:py-32 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Content - Profilbild */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden border border-accent-500/20 shadow-2xl hover:shadow-[0_0_40px_rgba(224,112,48,0.15)] transition-all duration-500 max-w-sm mx-auto lg:max-w-none">
              <img 
                src="/mee.jpeg"
                alt="Tobias"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-neutral-900/50 via-transparent to-transparent" />
            </div>
          </div>

          {/* Right Content - Text */}
          <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-medium mb-3">{SITE_CONTENT.about.eyebrow}</p>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6">
                {SITE_CONTENT.about.title}{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-400 to-accent-500">
                  {SITE_CONTENT.about.titleHighlight}
                </span>
              </h2>
            </div>
            
            <div className="space-y-3 md:space-y-4 text-neutral-300 leading-relaxed text-sm md:text-base">
              <p>{SITE_CONTENT.about.paragraph1}</p>
              <p>{SITE_CONTENT.about.paragraph2}</p>
              <p className="hidden md:block">{SITE_CONTENT.about.paragraph3}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 md:gap-6 pt-4 md:pt-6">
              {[
                // Anzahl zählt automatisch die Einträge in PROJECTS – neue Projekte erhöhen die Zahl von selbst
                { value: `${PROJECTS.length}`, label: SITE_CONTENT.about.stats.projects.label },
                SITE_CONTENT.about.stats.years,
                SITE_CONTENT.about.stats.clients,
              ].map((stat) => (
                <div key={stat.label} className="group text-center md:text-left">
                  <div className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-accent-400 to-accent-500 group-hover:scale-110 transition-transform duration-300">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-neutral-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Skills Section */}
          <div ref={skillsRef} className="space-y-4 md:space-y-6 order-3 lg:col-span-2">
            <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">{SITE_CONTENT.about.skillsTitle}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
              {SKILLS.map((skill, index) => (
                <div
                  key={skill.name}
                  className="group animate-fade-in"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="flex items-center justify-between mb-2">
                    <span className="flex items-center gap-2 text-sm font-medium">
                      <span className="text-xl">{skill.icon}</span>
                      {skill.name}
                    </span>
                    <span className="text-sm text-neutral-400">{skill.level}%</span>
                  </div>
                  <div className="h-2 bg-neutral-800 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-accent-500 to-accent-500 rounded-full group-hover:shadow-[0_0_20px_rgba(224,112,48,0.22)]"
                      style={{
                        width: isVisible ? `${skill.level}%` : '0%',
                        transition: 'width 2s ease-out',
                        transitionDelay: `${index * 200}ms`,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ImageCarousel({ project, onOpen }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = project.images || [project.image];

  if (!images || images.length === 0) {
    return (
      <div className="relative h-56 overflow-hidden bg-gradient-to-br from-neutral-900 to-neutral-800 flex items-center justify-center rounded-t-2xl">
        <span className="text-neutral-400">Kein Bild verfügbar</span>
      </div>
    );
  }

  const currentImage = images[currentImageIndex] || images[0];

  const nextImage = (e) => {
    e?.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e?.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="relative h-56 overflow-hidden bg-gradient-to-br from-neutral-900 to-neutral-800 rounded-t-2xl group">
      {/* Background blur effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-accent-500/10 to-accent-500/10 backdrop-blur-sm"></div>

      {/* Main Image */}
      <button
        type="button"
        onClick={() => onOpen && onOpen(images, currentImageIndex, project.title)}
        className="relative h-full w-full block cursor-zoom-in focus:outline-none"
        aria-label="Bild vergrößern"
      >
        <img
          src={currentImage}
          alt={`${project.title} - Bild ${currentImageIndex + 1}`}
          className="w-full h-full object-contain p-3 transition-all duration-500 ease-in-out transform group-hover:scale-105"
          key={`${currentImage}-${currentImageIndex}`}
        />

        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-900/20 via-transparent to-transparent pointer-events-none"></div>

        {/* Zoom hint */}
        <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-lg backdrop-blur-md bg-black/50 border border-white/10 text-white text-[11px] font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1 pointer-events-none">
          <svg className="w-3.5 h-3.5 text-accent-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M11 8v6M8 11h6M19 11a8 8 0 11-16 0 8 8 0 0116 0z" /></svg>
          Vergrößern
        </div>
      </button>

      {images.length > 1 && (
        <>
          {/* Previous Arrow Button */}
          <button
            onClick={prevImage}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-10 h-10 rounded-full bg-gradient-to-r from-accent-500 to-accent-500 text-white shadow-lg hover:shadow-xl hover:from-accent-400 hover:to-accent-400 transition-all duration-300 flex items-center justify-center group-hover:scale-110 z-10"
            aria-label="Vorheriges Bild"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Next Arrow Button */}
          <button
            onClick={nextImage}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 w-10 h-10 rounded-full bg-gradient-to-r from-accent-500 to-accent-500 text-white shadow-lg hover:shadow-xl hover:from-accent-400 hover:to-accent-400 transition-all duration-300 flex items-center justify-center group-hover:scale-110 z-10"
            aria-label="Nächstes Bild"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Modern Slide Indicators */}
          <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex gap-2">
            {images.map((_, index) => (
              <div
                key={index}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentImageIndex 
                    ? 'w-6 bg-accent-400 shadow-[0_0_8px_rgba(224,112,48,0.30)]' 
                    : 'w-2 bg-neutral-400/60'
                }`}
              >
              </div>
            ))}
          </div>

          {/* Modern Counter with Glass Effect */}
          <div className="absolute top-3 right-3 px-3 py-1 rounded-lg backdrop-blur-md bg-black/40 border border-white/10 text-white text-xs font-medium shadow-lg">
            <span className="text-accent-400">{currentImageIndex + 1}</span>
            <span className="text-neutral-300 mx-1">/</span>
            <span className="text-neutral-300">{images.length}</span>
          </div>
        </>
      )}
    </div>
  );
}

function Lightbox({ data, onClose }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (data) setIndex(data.index || 0);
  }, [data]);

  useEffect(() => {
    if (!data) return undefined;
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIndex((p) => (p + 1) % data.images.length);
      if (e.key === "ArrowLeft") setIndex((p) => (p - 1 + data.images.length) % data.images.length);
    };
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [data, onClose]);

  if (!data) return null;

  const { images, title } = data;
  const multiple = images.length > 1;
  const next = (e) => { e.stopPropagation(); setIndex((p) => (p + 1) % images.length); };
  const prev = (e) => { e.stopPropagation(); setIndex((p) => (p - 1 + images.length) % images.length); };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fade-in"
      onClick={onClose}
    >
      {/* Title */}
      {title && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 px-4 py-2 rounded-xl bg-black/60 border border-accent-500/30 text-accent-300 text-sm font-semibold max-w-[90vw] text-center">
          {title}
        </div>
      )}

      {/* Close */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/10 hover:bg-accent-500 border border-white/20 text-white flex items-center justify-center transition-all duration-300 z-10"
        aria-label="Schließen"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
      </button>

      {/* Image */}
      <img
        src={images[index]}
        alt={`${title || "Bild"} ${index + 1}`}
        onClick={(e) => e.stopPropagation()}
        className="max-h-[85vh] max-w-[90vw] object-contain rounded-xl shadow-[0_0_60px_rgba(224,112,48,0.12)]"
      />

      {multiple && (
        <>
          <button
            onClick={prev}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-accent-500 border border-white/20 text-white flex items-center justify-center transition-all duration-300"
            aria-label="Vorheriges Bild"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
          </button>
          <button
            onClick={next}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-accent-500 border border-white/20 text-white flex items-center justify-center transition-all duration-300"
            aria-label="Nächstes Bild"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
          </button>

          {/* Counter */}
          <div className="absolute bottom-5 left-1/2 -translate-x-1/2 px-4 py-1.5 rounded-full bg-black/60 border border-white/10 text-white text-sm font-medium">
            <span className="text-accent-400">{index + 1}</span>
            <span className="text-neutral-400 mx-1.5">/</span>
            <span className="text-neutral-300">{images.length}</span>
          </div>
        </>
      )}
    </div>
  );
}

function Projects() {
  const [headerImageIndex, setHeaderImageIndex] = useState(0);
  const [activeFilter, setActiveFilter] = useState('anwendung');
  const [lightbox, setLightbox] = useState(null);
  const openLightbox = (images, index, title) => setLightbox({ images, index, title });

  const headerImages = ["/app.neu.png", "/click_me.png", "/Projektbilder/banner.jpg"];

  // Auto-switch header image
  useEffect(() => {
    const interval = setInterval(() => {
      setHeaderImageIndex(prev => (prev + 1) % headerImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [headerImages.length]);

  const filteredProjects = PROJECTS.filter(project => project.category === activeFilter);

  const filters = [
    { id: 'anwendung', label: 'Anwendungen', count: PROJECTS.filter(p => p.category === 'anwendung').length },
    { id: 'webseite', label: 'Webseiten', count: PROJECTS.filter(p => p.category === 'webseite').length },
    { id: 'web-app', label: 'Web-Apps', count: PROJECTS.filter(p => p.category === 'web-app').length },
    { id: 'android-app', label: 'Android Apps', count: PROJECTS.filter(p => p.category === 'android-app').length },
    { id: 'gaming-lua', label: 'Gaming Code (Lua)', count: PROJECTS.filter(p => p.category === 'gaming-lua').length },
    { id: 'laufende-prozesse', label: 'Laufende Prozesse', count: PROJECTS.filter(p => p.category === 'laufende-prozesse').length },
  ];

  return (
    <section id="projekte" className="py-32 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-8 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-medium mb-3">{SITE_CONTENT.projects.eyebrow}</p>
          <h2 className="text-4xl md:text-6xl font-bold display-xl mb-6">{SITE_CONTENT.projects.title}</h2>
          <div className="mt-6 flex flex-col lg:flex-row items-center justify-center gap-8">
            <div className="relative group">
                <button
                onClick={() => setHeaderImageIndex(prev => (prev - 1 + headerImages.length) % headerImages.length)}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-black/50 hover:bg-accent-500 text-white p-2 rounded-full z-10 transition-all opacity-0 group-hover:opacity-100"
                aria-label="Previous"
                >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
                </button>

                <div className="flex justify-center">
                  <img
                    src={headerImages[headerImageIndex]}
                    alt="App Icon"
                    className="max-w-full h-auto transform hover:scale-105 transition-transform duration-300"
                    style={{background: 'transparent'}}
                  />
                </div>

                <button
                onClick={() => setHeaderImageIndex(prev => (prev + 1) % headerImages.length)}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-black/50 hover:bg-accent-500 text-white p-2 rounded-full z-10 transition-all opacity-0 group-hover:opacity-100"
                aria-label="Next"
                >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
                </button>
            </div>
            <div className="max-w-xl text-neutral-300 text-center lg:text-left bg-accent-500/10 border border-accent-400/40 rounded-2xl p-5 shadow-[0_0_25px_rgba(224,112,48,0.15)]">
              <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-accent-300 font-semibold mb-3 bg-accent-500/20 px-3 py-1 rounded-full">
                Hinweis
              </p>
              <p className="text-xs uppercase tracking-[0.3em] text-accent-300 font-semibold mb-2">
                App Installation
              </p>
              <p className="text-lg md:text-xl font-semibold text-neutral-100">
                Android & iOS unterstützt
              </p>
              <p className="mt-2 text-sm md:text-base leading-relaxed text-neutral-200">
                Mit meinem Install-Button kann man die Seite –
                direkt als App auf deinem Homescreen speichern.
              </p>
            </div>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`w-full sm:w-auto text-center px-4 py-2 sm:px-6 sm:py-2.5 rounded-xl font-medium text-xs sm:text-sm transition-all duration-300 ${
                activeFilter === filter.id
                  ? 'bg-accent-500 text-white shadow-[0_0_20px_rgba(224,112,48,0.22)]'
                  : 'bg-neutral-800 text-neutral-300 hover:bg-neutral-700 border border-neutral-700 hover:border-accent-500/50'
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <article
              key={project.title}
              className="group relative rounded-2xl border border-accent-500/20 bg-neutral-800/90 backdrop-blur-sm overflow-hidden hover:border-accent-400/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_32px_0_#e0703033] animate-fade-in"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Project Image / Galerie */}
              <ImageCarousel project={project} onOpen={openLightbox} />

              {/* Content */}
              <div className="relative p-6 space-y-4">
                <h3 className="text-xl font-bold text-accent-400 mb-3 group-hover:text-accent-300 transition-colors duration-300">
                  {project.title}
                </h3>
                <p className="text-sm text-neutral-300 leading-relaxed line-clamp-4">
                  {project.description}
                </p>

                {/* Links */}
                <div className="flex flex-wrap gap-2 pt-2">
                  {project.link && project.link !== "#" ? (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-accent-500 text-white font-bold hover:bg-accent-400 transition-all duration-300"
                    >
                      {project.buttonText || SITE_CONTENT.projects.demoButton}
                      <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                    </a>
                  ) : project.isGallery && project.images?.length ? (
                    <button
                      type="button"
                      onClick={() => openLightbox(project.images, 0, project.title)}
                      className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-accent-500 text-white font-bold hover:bg-accent-400 transition-all duration-300"
                    >
                      Galerie ansehen
                      <span className="bg-white/20 rounded-md px-1.5 py-0.5 text-xs">{project.images.length} Bilder</span>
                    </button>
                  ) : (
                    <span className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-neutral-600 text-neutral-400 font-bold cursor-not-allowed">
                      In Entwicklung
                      <span>⏳</span>
                    </span>
                  )}
                  {project.secondaryLink && (
                    <a
                      href={project.secondaryLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-accent-700 text-white font-bold hover:bg-accent-400 transition-all duration-300"
                    >
                      {SITE_CONTENT.projects.adminButton}
                    </a>
                  )}
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-neutral-900 text-white font-bold border border-neutral-600 hover:border-accent-400 hover:bg-neutral-800 transition-all duration-300"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M12 .5C5.37.5 0 5.87 0 12.5c0 5.3 3.44 9.8 8.21 11.39.6.11.82-.26.82-.58 0-.29-.01-1.04-.02-2.05-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.33-1.76-1.33-1.76-1.09-.75.08-.73.08-.73 1.2.08 1.84 1.24 1.84 1.24 1.07 1.83 2.81 1.3 3.5.99.11-.78.42-1.3.76-1.6-2.67-.3-5.47-1.34-5.47-5.96 0-1.32.47-2.39 1.24-3.23-.13-.3-.54-1.53.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.65.25 2.88.12 3.18.77.84 1.24 1.91 1.24 3.23 0 4.63-2.81 5.65-5.49 5.95.43.37.81 1.1.81 2.22 0 1.61-.01 2.9-.01 3.29 0 .32.21.7.82.58A12.01 12.01 0 0 0 24 12.5C24 5.87 18.63.5 12 .5z"/>
                      </svg>
                      Code &amp; Download
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <Lightbox data={lightbox} onClose={() => setLightbox(null)} />
    </section>
  );
}

function Experience() {
  return (
    <section id="skills" className="py-32 scroll-mt-24 bg-neutral-900/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-medium mb-3">{SITE_CONTENT.experience.eyebrow}</p>
          <h2 className="text-4xl md:text-6xl font-bold display-xl">{SITE_CONTENT.experience.title}</h2>
        </div>

        <div 
          className="max-w-4xl mx-auto space-y-6 pr-4"
          style={{
            maxHeight: '600px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#e07030 #1a1714'
          }}
        >
          {EXPERIENCE.map((item, index) => (
            <div
              key={item.role}
              className="group relative rounded-2xl border border-white/10 bg-neutral-900/50 backdrop-blur-sm p-6 hover:border-accent-500/50 hover:bg-neutral-900/80 transition-all duration-500 animate-fade-in"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Timeline Dot */}
              <div className="absolute -left-3 top-8 h-6 w-6 rounded-full bg-gradient-to-br from-accent-500 to-accent-500 border-4 border-neutral-950 group-hover:scale-125 group-hover:shadow-[0_0_20px_rgba(224,112,48,0.25)] transition-all duration-300" />

              <div className="flex flex-wrap items-start justify-between gap-4 mb-3">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <h3 className="text-xl font-semibold group-hover:text-accent-400 transition-colors">
                      {item.role}
                    </h3>
                    {item.badge && (
                      <span className="px-2.5 py-0.5 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400">
                        {item.badge}
                      </span>
                    )}
                  </div>
                  <p className="text-neutral-400">{item.company}</p>
                </div>
                <span className="text-sm text-neutral-500 font-mono">{item.period}</span>
              </div>

              <p className="text-neutral-300 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Certificates() {
  return (
    <section id="zertifikat" className="py-32 scroll-mt-24 bg-neutral-900/80">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-medium mb-3">{SITE_CONTENT.certificates.eyebrow}</p>
          <h2 className="text-4xl md:text-6xl font-bold display-xl">{SITE_CONTENT.certificates.title}</h2>
        </div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
          {CERTIFICATES.map((cert, index) => (
            <div
              key={cert.title}
              className="group relative rounded-2xl border border-accent-500/20 bg-neutral-800/90 backdrop-blur-sm overflow-hidden hover:border-accent-400/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_32px_0_#e0703033] animate-fade-in p-8"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Certificate Image */}
              <div className="relative mb-6 rounded-xl overflow-hidden">
                <img 
                  src={cert.image} 
                  alt={cert.title}
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="space-y-3">
                <h3 className="text-xl font-bold text-accent-400 group-hover:text-accent-300 transition-colors duration-300">
                  {cert.title}
                </h3>
                <p className="text-sm text-neutral-400">{cert.description}</p>
                <div className="flex items-center justify-between pt-3 border-t border-neutral-700">
                  <span className="text-sm text-neutral-400">{cert.issuer}</span>
                  <span className="text-sm font-semibold text-accent-400">{cert.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Setup() {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const setupItems = [
    {
      category: "💻 Hardware",
      items: [
        { name: "Laptop", spec: "MacBook Pro 16\" / M3 Max / 64GB RAM", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=MacBook" },
        { name: "Monitor", spec: "2x 27\" 4K Display", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Monitor" },
        { name: "Tastatur", spec: "Mechanische RGB Tastatur", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Keyboard" },
        { name: "Maus", spec: "Logitech MX Master 3", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Mouse" },
      ]
    },
    {
      category: "🛠️ Software & Tools",
      items: [
        { name: "Editor", spec: "VS Code mit GitHub Copilot", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=VS+Code" },
        { name: "Design", spec: "Figma & Adobe Creative Suite", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Design+Tools" },
        { name: "Terminal", spec: "Windows Terminal mit PowerShell", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Terminal" },
        { name: "Browser", spec: "Chrome DevTools & Firefox", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Browser" },
      ]
    },
    {
      category: "🎨 Development Stack",
      items: [
        { name: "Frontend", spec: "React, Next.js, Tailwind CSS", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=React" },
        { name: "Backend", spec: "Node.js, PHP, MySQL", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Backend" },
        { name: "Tools", spec: "Git, Docker, Postman", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=Dev+Tools" },
        { name: "KI", spec: "ChatGPT, GitHub Copilot, Claude", image: "https://via.placeholder.com/600x400/1e293b/06b6d4?text=AI+Tools" },
      ]
    }
  ];

  return (
    <section id="setup" className="py-32 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 text-accent-400 text-sm font-medium">
            {SITE_CONTENT.setup.eyebrow}
          </span>
          <h2 className="text-4xl md:text-6xl font-bold display-xl">
            {SITE_CONTENT.setup.title}{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-400 to-accent-500">
              {SITE_CONTENT.setup.titleHighlight}
            </span>
          </h2>
          <p className="text-lg text-neutral-400 max-w-2xl mx-auto">
            {SITE_CONTENT.setup.description}
          </p>
        </div>

        {/* Setup Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {setupItems.map((section, idx) => (
            <div
              key={idx}
              className="group relative bg-neutral-900/50 backdrop-blur-sm border border-neutral-800 rounded-2xl p-6 hover:border-accent-500/50 transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${idx * 150}ms` }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-accent-500/5 to-accent-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              
              <div className="relative space-y-6">
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  {section.category}
                </h3>
                
                <div className="space-y-4">
                  {section.items.map((item, itemIdx) => (
                    <div
                      key={itemIdx}
                      className={`relative flex items-start gap-3 p-3 rounded-lg bg-neutral-800/50 hover:bg-neutral-800 transition-colors duration-300 ${idx === 0 ? 'cursor-pointer' : ''}`}
                      onMouseEnter={idx === 0 ? () => setHoveredItem(item) : undefined}
                      onMouseLeave={idx === 0 ? () => setHoveredItem(null) : undefined}
                      onClick={idx === 0 ? () => setSelectedItem(item) : undefined}
                    >
                      <div className="h-2 w-2 rounded-full bg-accent-400 mt-2 flex-shrink-0" />
                      <div className="flex-1">
                        <p className="text-sm font-semibold text-white">{item.name}</p>
                        <p className="text-xs text-neutral-400 mt-1">{item.spec}</p>
                      </div>
                      {idx === 0 && <span className="text-accent-400 text-xs">🖼️ Klick für Bild</span>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Image Modal */}
        {selectedItem && (
          <div 
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 animate-fade-in"
            onClick={() => setSelectedItem(null)}
          >
            <div className="relative max-w-4xl w-full bg-neutral-900 border border-accent-500/50 rounded-2xl p-6 shadow-2xl">
              <button
                onClick={() => setSelectedItem(null)}
                className="absolute top-4 right-4 h-10 w-10 rounded-lg bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 hover:border-accent-500 transition-all duration-300 flex items-center justify-center text-white"
              >
                ✕
              </button>
              <div className="space-y-4">
                <div>
                  <h3 className="text-2xl font-bold text-white">{selectedItem.name}</h3>
                  <p className="text-neutral-400 mt-1">{selectedItem.spec}</p>
                </div>
                <img
                  src={selectedItem.image}
                  alt={selectedItem.name}
                  className="w-full h-auto rounded-xl"
                />
              </div>
            </div>
          </div>
        )}

        {/* Fun Fact Box */}
        <div className="mt-12 bg-gradient-to-r from-accent-500/10 to-accent-500/10 border border-accent-500/20 rounded-2xl p-8 text-center">
          <p className="text-lg text-neutral-300">
            💡 <span className="font-semibold text-white">Fun Fact:</span> Über 5.000 Zeilen Code wurden in diesem Setup bereits geschrieben!
          </p>
        </div>
      </div>
    </section>
  );
}

function ReviewModal({ isOpen, onClose, onAddReview }) {
  const [rating, setRating] = useState(5);
  const [name, setName] = useState("");
  const [review, setReview] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        // Starte das Speichern der Bewertung
        await onAddReview({ name, rating, text: review });
        
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          onClose();
          setName("");
          setReview("");
          setRating(5);
        }, 2000);
    } catch (error) {
        console.error("Fehler", error);
        alert("Fehler beim Speichern. Bitte später versuchen.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-neutral-900 border border-white/10 p-6 rounded-2xl max-w-md w-full relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-400 hover:text-white"
        >
          ✕
        </button>
        
        <h3 className="text-xl font-bold mb-4 text-white">Bewertung schreiben</h3>
        
        {success ? (
          <div className="text-center py-8 text-green-400">
            <p className="text-xl">Vielen Dank für deine Bewertung! 🎉</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-neutral-400 mb-1">Dein Name</label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-accent-500"
                placeholder="Name"
              />
            </div>
            
            <div>
              <label className="block text-sm text-neutral-400 mb-1">Bewertung</label>
              <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    onClick={() => setRating(star)}
                    className={`text-2xl transition-colors ${rating >= star ? 'text-yellow-400' : 'text-neutral-600'}`}
                  >
                    ★
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm text-neutral-400 mb-1">Deine Erfahrung</label>
              <textarea
                required
                value={review}
                onChange={(e) => setReview(e.target.value)}
                rows={4}
                className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-accent-500"
                placeholder="Wie war die Zusammenarbeit?"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-accent-500 to-accent-500 text-white font-bold py-3 rounded-xl hover:shadow-lg transition-all disabled:opacity-50"
            >
              {loading ? "Sende..." : "Bewertung absenden"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

function KISchulungen({ setSelectedPackage }) {
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviews, setReviews] = useState([]);

  // Launch der neuen Seite: 29. August 2026, 06:00 Uhr
  const LAUNCH_TS = new Date(2026, 7, 29, 6, 0, 0).getTime();
  const [nowTs, setNowTs] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNowTs(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const launchDiff = LAUNCH_TS - nowTs;
  const launched = launchDiff <= 0;
  const countdown = (() => {
    const t = Math.max(0, Math.floor(launchDiff / 1000));
    const d = Math.floor(t / 86400);
    const h = Math.floor((t % 86400) / 3600);
    const m = Math.floor((t % 3600) / 60);
    const s = t % 60;
    const p = (n) => String(n).padStart(2, "0");
    return `${d} Tage ${p(h)}:${p(m)}:${p(s)}`;
  })();

  // Beim Laden der Seite: Eindeutigen User-Token erstellen oder laden
  const [userToken] = useState(() => {
    let token = localStorage.getItem('userToken');
    if (!token) {
      token = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2);
      localStorage.setItem('userToken', token);
    }
    return token;
  });

  // Bewertungen vom Server laden (oder LocalStorage als Fallback)
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch('reviews.php');
        if (response.ok) {
          const data = await response.json();
          // Markiere Bewertungen als "Eigene", wenn das Token übereinstimmt
          const markedReviews = data.map(review => ({
            ...review,
            isOwned: true // DEBUG: Erlaube Löschen für alle Bewertungen
          }));
          setReviews(markedReviews);
        } else {
            // Fallback für LocalHost (wenn kein PHP Server läuft)
            console.warn("Backend (reviews.php) nicht erreichbar. Nutze LocalStorage.");
            const savedReviews = localStorage.getItem('userReviews');
            if (savedReviews) setReviews(JSON.parse(savedReviews));
        }
      } catch (error) {
        console.error("Fehler beim Laden der Bewertungen:", error);
        // Fallback
        const savedReviews = localStorage.getItem('userReviews');
        if (savedReviews) setReviews(JSON.parse(savedReviews));
      }
    };

    fetchReviews();
  }, [userToken]);


  const handleAddReview = async (newReviewInput) => {
    // Sende an Server
    try {
        const response = await fetch('reviews.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...newReviewInput,
                ownerToken: userToken // Sende Token mit, damit Server weiß wer Besitzer ist
            })
        });

        if (response.ok) {
            const result = await response.json();
            if (result.success && result.review) {
                // Erfolgreich gespeichert -> Update State
                const addedReview = { ...result.review, isOwned: true };
                setReviews(prev => [addedReview, ...prev]);
            }
        } else {
            // Wenn Server fehlschlägt (z.B. auf LocalHost), nutze LocalStorage
            console.warn("Speichern fehlgeschlagen, nutze LocalStorage");
            const localReview = { ...newReviewInput, id: Date.now(), isOwned: true, date: new Date().toLocaleDateString('de-DE') };
            const updated = [localReview, ...reviews];
            setReviews(updated);
            localStorage.setItem('userReviews', JSON.stringify(updated));
        }
    } catch (e) {
        console.error("Netzwerkfehler beim Speichern", e);
        const localReview = { ...newReviewInput, id: Date.now(), isOwned: true, date: new Date().toLocaleDateString('de-DE') };
            const updated = [localReview, ...reviews];
            setReviews(updated);
            localStorage.setItem('userReviews', JSON.stringify(updated));
    }
  };

  const handleDeleteReview = async (id) => {
    // Sende Lösch-Anfrage an Server mit Token
    try {
        const response = await fetch(`reviews.php?id=${id}`, {
            method: 'DELETE',
            headers: {
                'X-User-Token': userToken // Token im Header senden zur Verifizierung
            }
        });

        if (response.ok) {
             setReviews(prev => prev.filter(r => r.id !== id));
        } else {
            console.warn("Löschen fehlgeschlagen (Server), versuche LocalStorage");
             // Fallback LocalStorage
             const updated = reviews.filter(r => r.id !== id);
             setReviews(updated);
             localStorage.setItem('userReviews', JSON.stringify(updated));
        }

    } catch (e) {
        console.error("Fehler beim Löschen", e);
        // Fallback LocalStorage
        const updated = reviews.filter(r => r.id !== id);
        setReviews(updated);
        localStorage.setItem('userReviews', JSON.stringify(updated));
    }
  };
    
  const packages = [
    {
      id: 1,
      name: "Kickstart",
      subtitle: "Beratung",
      price: "49 €",
      features: ["30 Min Call", "Projekt-Check", "Empfehlungen"],
      color: "from-emerald-500 to-accent-500",
    },
    {
      id: 2,
      name: "KI Smart",
      subtitle: "Coaching",
      price: "149 €",
      features: ["90 Min 1:1", "GPT & Claude", "Prompt-Vorlagen"],
      color: "from-accent-500 to-accent-500",
    },
    {
      id: 3,
      name: "Prototyp",
      subtitle: "Design",
      price: "399 €",
      features: ["Figma-Prototyp", "User-Flow", "Feedback-Runde"],
      color: "from-accent-500 to-accent-500",
    },
    {
      id: 4,
      name: "App Starter",
      subtitle: "Entwicklung",
      price: "ab 799 €",
      features: ["MVP App", "iOS / Android", "Code-Übergabe"],
      color: "from-orange-500 to-rose-500",
    },
    {
      id: 5,
      name: "Tech Buddy",
      subtitle: "Support",
      price: "99 €/mtl",
      features: ["2 Calls/Monat", "WhatsApp-Support", "Dein Ansprechpartner"],
      color: "from-accent-500 to-accent-500",
    },
  ];

  const handleBookPackage = (pkg) => {
    setSelectedPackage(pkg);
    // Scroll zum Kontaktformular
    document.getElementById('kontakt').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="ki-schulungen" className="py-32 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-medium mb-3">Meine Pakete</p>
          <h2 className="text-4xl md:text-6xl font-bold display-xl mb-4">
            KI‑Schulungen{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-400 to-accent-500">
              & Begleitung
            </span>
          </h2>
          <p className="text-neutral-400 max-w-2xl mx-auto">
            Von der ersten Idee bis zur fertigen App – wähle dein Paket
          </p>
        </div>

        {/* Container mit Overlay */}
        <div className="relative min-h-[600px] sm:min-h-[520px]">
          {/* All 5 Packages in One Row */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {packages.map((pkg) => (
              <div
                key={pkg.id}
                className="relative rounded-2xl border border-white/10 bg-neutral-900/60 backdrop-blur-sm p-5 hover:border-accent-500/40 transition-all duration-300 hover:transform hover:scale-[1.03] flex flex-col"
              >
                <div className="text-center mb-4">
                  <p className="text-[10px] text-neutral-500 uppercase tracking-wider">{pkg.subtitle}</p>
                  <h3 className="text-lg font-bold text-white">{pkg.name}</h3>
                  <div className={`text-xl font-bold mt-2 text-transparent bg-clip-text bg-gradient-to-r ${pkg.color}`}>
                    {pkg.price}
                  </div>
                </div>

                <ul className="space-y-2 mb-4 flex-grow">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-1.5 text-xs text-neutral-300">
                      <span className="text-accent-400 text-[10px]">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => handleBookPackage(pkg)}
                  className={`w-full inline-flex items-center justify-center gap-1 rounded-lg bg-gradient-to-r ${pkg.color} px-3 py-2 text-xs font-semibold text-white hover:shadow-lg transition-all duration-300`}
                >
                  Anfragen <span>→</span>
                </button>
              </div>
            ))}
          </div>

          {/* Overlay - Jetzt auf neuer Seite buchbar (Hintergrund = Screenshot der neuen Seite) */}
          <div className="absolute inset-0 z-10 rounded-2xl overflow-hidden">
            {/* Hintergrund: Screenshot der neuen Seite */}
            <img
              src="/it-kicodebyts-preview.webp"
              alt="Vorschau der neuen Seite it-kicodebyts.com"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            {/* Abdunkelung für gute Lesbarkeit */}
            <div className="absolute inset-0 bg-neutral-950/75"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/55 to-neutral-950/85"></div>

            {/* Inhalts-Karte */}
            <div className="relative h-full flex items-center justify-center p-4 sm:p-6">
              <div className="text-center w-full max-w-2xl rounded-2xl border border-accent-400/20 bg-neutral-900/70 backdrop-blur-md p-6 md:p-10 shadow-[0_0_40px_rgba(0,0,0,0.5)]">
                <span className="inline-flex items-center gap-2 mb-4 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-400/40 text-accent-300 text-[11px] font-semibold uppercase tracking-[0.2em]">
                  ✨ {launched ? "Jetzt online" : "Bald verfügbar"}
                </span>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                  {launched ? "Jetzt buchbar auf meiner Seite" : "Bald buchbar auf meiner Seite"}
                </h3>
                <p className="text-neutral-300 text-sm md:text-base mb-6 max-w-xl mx-auto">
                  Alle KI-Schulungen &amp; IT-Leistungen {launched ? "gibt es jetzt" : "gibt es bald gebündelt"} auf meiner Seite.
                </p>

                {/* Countdown-Hinweis bis zum Launch */}
                {!launched && (
                  <div className="mb-6 rounded-xl border border-accent-400/30 bg-accent-500/10 px-5 py-4">
                    <p className="text-[11px] uppercase tracking-[0.2em] text-accent-300 font-semibold flex items-center justify-center gap-2">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                      Verfügbar ab 29. August · 6:00 Uhr
                    </p>
                    <p className="mt-1.5 text-xl md:text-2xl font-bold text-white tabular-nums">{countdown}</p>
                  </div>
                )}

                {/* Haupt-Buttons nebeneinander */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  {launched ? (
                    <a
                      href="http://it-kicodebyts.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-accent-400 text-neutral-950 font-semibold hover:bg-accent-300 transition-all duration-300"
                    >
                      Schau vorbei <span>→</span>
                    </a>
                  ) : (
                    <span
                      aria-disabled="true"
                      title="Verfügbar ab 29. August, 6:00 Uhr"
                      className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white/5 border border-white/15 text-neutral-400 font-semibold cursor-not-allowed select-none"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                      Schau vorbei
                    </span>
                  )}
                  <a
                    href="#kontakt"
                    className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white/10 border border-white/20 text-white font-semibold hover:bg-white/20 hover:border-accent-500/40 transition-all duration-300"
                  >
                    Kontakt aufnehmen <span>→</span>
                  </a>
                </div>

                {/* Sekundär: dezenter Textlink */}
                <button
                  onClick={() => setIsReviewModalOpen(true)}
                  className="mt-4 text-sm text-neutral-400 hover:text-accent-300 underline underline-offset-4 transition-colors"
                >
                  Bewertung schreiben ✍️
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Reviews Section */}
        {reviews.length > 0 && (
          <div className="mt-16 relative z-20">
            <h3 className="text-2xl font-bold text-center mb-8">
              Kundenstimmen
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {reviews.map((review) => (
                <div 
                  key={review.id}
                  className="bg-neutral-900/50 border border-white/10 rounded-xl p-6 backdrop-blur-sm relative group"
                >
                  {/* Nur anzeigen, wenn es die eigene Bewertung ist (oder keine Flagge existiert für alte Daten) */}
                  {(review.isOwned === true || review.isOwned === undefined) && (
                    <button 
                      onClick={() => handleDeleteReview(review.id)}
                      className="absolute top-2 right-2 p-2 text-neutral-600 hover:text-red-500 hover:bg-red-500/10 rounded-full transition-all"
                      title="Bewertung löschen"
                    >
                      ✕
                    </button>
                  )}
                  <div className="flex items-center justify-between mb-4 pr-8">
                    <div className="font-semibold text-white">{review.name}</div>
                    <div className="text-yellow-400 text-sm flex-shrink-0">
                      {"★".repeat(review.rating)}
                      <span className="text-neutral-600">{"★".repeat(5 - review.rating)}</span>
                    </div>
                  </div>
                  <p className="text-neutral-300 text-sm italic mb-4">"{review.text}"</p>
                  <div className="text-xs text-neutral-500 text-right">{review.date}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Review Modal */}
        <ReviewModal 
          isOpen={isReviewModalOpen} 
          onClose={() => setIsReviewModalOpen(false)} 
          onAddReview={handleAddReview}
        />

        {/* Hinweis unverbindlich */}
        <p className="text-center text-sm text-neutral-500 mt-6">
          Alle Anfragen sind unverbindlich – ich melde mich zeitnah bei dir.
        </p>

        {/* CTA Box */}
        <div className="mt-8 bg-gradient-to-r from-accent-500/10 to-accent-500/10 border border-accent-500/20 rounded-2xl p-6 text-center">
          <p className="text-base text-neutral-300">
            <span className="font-semibold text-white">Unsicher?</span>{" "}
            Schreib mir – wir finden das passende Paket!
          </p>
        </div>
      </div>
    </section>
  );
}

function Contact({ deferredPrompt, setDeferredPrompt, selectedPackage, setSelectedPackage }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    website: "",
    message: "",
  });
  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: null,
    message: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidEmail = (email) => {
    // Basis-Format-Prüfung
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return false;

    // Domain-Extraktion
    const domain = email.split('@')[1];
    if (!domain) return false;

    // TLD (Top-Level-Domain) muss mindestens 2 Zeichen haben
    const tld = domain.split('.').pop();
    if (!tld || tld.length < 2) return false;

    // Erweiterte Spam-Blockierung
    const invalidDomains = [
      'test', 'example', 'localhost', 'dummy', 'fake', 'sample',
      'temp', 'tempmail', '10minutemail', 'guerrillamail', 'mailinator',
      'throwaway', 'discard', 'spam', 'trash', 'yopmail'
    ];
    const domainWithoutTld = domain.split('.')[0].toLowerCase();
    
    // Prüfe auf verdächtige Muster
    const suspiciousPatterns = [
      /temp/i, /mail\d+/i, /test\d+/i, /fake/i, /spam/i, /trash/i
    ];
    
    if (invalidDomains.includes(domainWithoutTld) || 
        invalidDomains.includes(tld.toLowerCase()) ||
        suspiciousPatterns.some(pattern => pattern.test(domain))) {
      return false;
    }

    return true;
  };

  // Einfacher Spam-Filter
  const isSpamMessage = (name, message) => {
    const spamKeywords = [
      'viagra', 'casino', 'lottery', 'winner', 'click here',
      'make money', 'free money', 'earn money fast'
    ];
    const text = (name + ' ' + message).toLowerCase();
    return spamKeywords.some(keyword => text.includes(keyword));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validiere E-Mail-Adresse
    if (!isValidEmail(formData.email)) {
      setFormStatus({
        loading: false,
        success: false,
        message: "Bitte gib eine gültige E-Mail-Adresse ein.",
      });
      return;
    }

    // Spam-Check
    if (isSpamMessage(formData.name, formData.message)) {
      setFormStatus({
        loading: false,
        success: false,
        message: "Nachricht wurde als Spam erkannt. Bitte überarbeite deine Nachricht.",
      });
      return;
    }

    // Mindestlänge für Name und Nachricht
    if (formData.name.length < 2) {
      setFormStatus({
        loading: false,
        success: false,
        message: "Name muss mindestens 2 Zeichen lang sein.",
      });
      return;
    }

    if (formData.message.length < 10) {
      setFormStatus({
        loading: false,
        success: false,
        message: "Nachricht muss mindestens 10 Zeichen lang sein.",
      });
      return;
    }

    setFormStatus({ loading: true, success: null, message: "" });

    try {
      const response = await fetch("/send-email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          website: formData.website,
          message: formData.message,
          selectedPackage: selectedPackage ? `${selectedPackage.name} (${selectedPackage.price})` : null,
        }),
      });

      const result = await response.json();
      if (response.ok && result.success) {
        setFormStatus({ loading: false, success: true, message: result.message });
        setFormData({ name: "", email: "", website: "", message: "" });
        setSelectedPackage(null); // Paket-Auswahl zurücksetzen
      } else {
        setFormStatus({
          loading: false,
          success: false,
          message: result.message || "Nachricht konnte nicht gesendet werden.",
        });
      }
    } catch (error) {
      setFormStatus({
        loading: false,
        success: false,
        message: "Serverfehler. Bitte später erneut versuchen.",
      });
    }
  };

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      alert('Die App-Installation ist derzeit nicht verfügbar. Bitte öffne diese Seite über einen unterstützten Browser (Chrome, Edge, Safari).');
      return;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('App wurde installiert');
    }
    
    setDeferredPrompt(null);
  };

  return (
    <section id="kontakt" className="py-32 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-medium mb-3">{SITE_CONTENT.contact.eyebrow}</p>
            <h2 className="text-4xl md:text-6xl font-bold display-xl mb-4">
              {SITE_CONTENT.contact.title}{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-400 to-accent-500">
                {SITE_CONTENT.contact.titleHighlight}
              </span>{" "}
              {SITE_CONTENT.contact.titleEnd}
            </h2>
            <p className="text-neutral-400 max-w-2xl mx-auto">
              {SITE_CONTENT.contact.description}
            </p>
          </div>

          <div className="grid md:grid-cols-[1.5fr,1fr] gap-12 items-start">
            {/* Contact Form */}
            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Ausgewähltes Paket anzeigen */}
              {selectedPackage && (
                <div className="relative rounded-xl border-2 border-accent-500/50 bg-gradient-to-r from-accent-500/10 to-accent-500/10 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-xs text-accent-400 font-medium">Ausgewähltes Paket</p>
                      <p className="text-white font-bold">{selectedPackage.name} <span className="text-accent-400">({selectedPackage.price})</span></p>
                      <p className="text-xs text-neutral-400 mt-1">Unverbindliche Anfrage</p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setSelectedPackage(null)}
                      className="text-neutral-400 hover:text-white transition-colors p-1"
                      title="Paket entfernen"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              )}

              <div className="group">
                <label className="block text-sm font-medium text-neutral-300 mb-2 group-focus-within:text-accent-400 transition-colors">
                  {SITE_CONTENT.contact.form.nameLabel}
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-neutral-900/50 border border-neutral-700 text-white placeholder:text-neutral-500 focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 hover:border-neutral-600 transition-all duration-300"
                  placeholder={SITE_CONTENT.contact.form.namePlaceholder}
                />
              </div>

              <div className="group">
                <label className="block text-sm font-medium text-neutral-300 mb-2 group-focus-within:text-accent-400 transition-colors">
                  {SITE_CONTENT.contact.form.emailLabel}
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-neutral-900/50 border border-neutral-700 text-white placeholder:text-neutral-500 focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 hover:border-neutral-600 transition-all duration-300"
                  placeholder={SITE_CONTENT.contact.form.emailPlaceholder}
                />
                <p className="text-xs text-neutral-400 mt-1">📧 {formData.email || 'deine@email.de'}</p>
              </div>

              <div className="group">
                <label className="block text-sm font-medium text-neutral-300 mb-2 group-focus-within:text-accent-400 transition-colors">
                  {SITE_CONTENT.contact.form.websiteLabel}
                </label>
                <input
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-neutral-900/50 border border-neutral-700 text-white placeholder:text-neutral-500 focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 hover:border-neutral-600 transition-all duration-300"
                  placeholder={SITE_CONTENT.contact.form.websitePlaceholder}
                />
              </div>

              <div className="group">
                <label className="block text-sm font-medium text-neutral-300 mb-2 group-focus-within:text-accent-400 transition-colors">
                  {SITE_CONTENT.contact.form.messageLabel}
                </label>
                <textarea
                  rows="5"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-neutral-900/50 border border-neutral-700 text-white placeholder:text-neutral-500 focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 hover:border-neutral-600 resize-none transition-all duration-300"
                  placeholder={SITE_CONTENT.contact.form.messagePlaceholder}
                />
              </div>

              <button
                type="submit"
                disabled={formStatus.loading}
                className="group relative w-full px-8 py-4 rounded-xl bg-gradient-to-r from-accent-500 to-accent-500 text-white font-medium overflow-hidden hover:shadow-[0_0_40px_rgba(224,112,48,0.22)] transition-all duration-300 hover:scale-[1.02]"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-accent-500 to-accent-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="relative flex items-center justify-center gap-2">
                  {SITE_CONTENT.contact.form.submitButton}
                  <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                </span>
              </button>
              {formStatus.message && (
                <p
                  className={`text-sm mt-3 ${
                    formStatus.success ? "text-green-400" : "text-rose-400"
                  }`}
                >
                  {formStatus.message}
                </p>
              )}
            </form>

            {/* Contact Info */}
            <div className="space-y-8">
              <div className="rounded-2xl border border-white/10 bg-neutral-900/50 backdrop-blur-sm p-6 hover:border-accent-500/50 transition-all duration-300">
                <h3 className="text-lg font-semibold mb-4">{SITE_CONTENT.contact.direct.title}</h3>
                <div className="space-y-4">
                  <a
                    href={`https://wa.me/${SITE_CONTENT.contact.direct.whatsapp.number.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(SITE_CONTENT.contact.direct.whatsapp.text)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-neutral-300 hover:text-green-400 transition-colors group"
                  >
                    <span className="flex items-center justify-center h-10 w-10 rounded-lg bg-green-600 group-hover:bg-green-500 transition-colors">
                      <img src="/wahtsapp.png" alt="WhatsApp" className="w-6 h-6 object-contain" />
                    </span>
                    <span className="text-sm">{SITE_CONTENT.contact.direct.whatsapp.label}</span>
                  </a>
                  <a
                    href={SITE_CONTENT.contact.direct.github.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-neutral-300 hover:text-accent-400 transition-colors group"
                  >
                    <span className="flex items-center justify-center h-10 w-10 rounded-lg bg-neutral-800 group-hover:bg-neutral-700 transition-colors">
                      <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                        <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                      </svg>
                    </span>
                    <span className="text-sm">{SITE_CONTENT.contact.direct.github.label}</span>
                  </a>
                  <a
                    href={SITE_CONTENT.contact.direct.instagram.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-neutral-300 hover:text-accent-400 transition-colors group"
                  >
                    <span className="flex items-center justify-center h-10 w-10 rounded-lg bg-neutral-800 group-hover:bg-neutral-700 transition-colors">
                      <img src="/insta.png" alt="Instagram" className="w-6 h-6 object-contain filter grayscale group-hover:grayscale-0 transition duration-200" />
                    </span>
                    <span className="text-sm">{SITE_CONTENT.contact.direct.instagram.label}</span>
                  </a>
                </div>
              </div>

              <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/5 p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="relative flex h-2.5 w-2.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
                  </span>
                  <span className="text-sm font-medium text-emerald-400">{SITE_CONTENT.contact.availability.status}</span>
                </div>
                <p className="text-xs text-neutral-400">
                  {SITE_CONTENT.contact.availability.note}
                </p>
              </div>

              {/* PWA Install Box */}
              <div id="install-button" className="rounded-2xl border border-accent-500/20 bg-accent-500/5 p-6 hover:border-accent-500/40 transition-all duration-300">
                <div className="flex items-center gap-2 mb-2">
                  <div className="h-6 w-6 rounded-lg overflow-hidden">
                    <img src="/Meinlogo-animiert.gif" alt="Logo" className="w-full h-full object-cover" />
                  </div>
                  <span className="text-sm font-medium text-accent-400">Portfolio als App</span>
                </div>
                <p className="text-xs text-neutral-400 mb-4">
                  Installiere mein Portfolio als App auf deinem Gerät für schnellen Zugriff.
                </p>
                <button
                  onClick={handleInstallClick}
                  className="w-full px-4 py-2 rounded-lg bg-gradient-to-r from-accent-500 to-accent-500 text-white text-sm font-medium hover:shadow-[0_0_20px_rgba(224,112,48,0.22)] transition-all duration-300 flex items-center justify-center gap-2"
                >
                  <div className="h-5 w-5 rounded overflow-hidden">
                    <img src="/Meinlogo-animiert.gif" alt="Logo" className="w-full h-full object-cover" />
                  </div>
                  Jetzt installieren
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default App;
